import type { TimeCommitment } from 'bundles/adaptive-learning-common/types';

export const DEFAULT_TIME_COMMITMENT: TimeCommitment = 30;

export const AI_GENERATED_ROUTE_PREFIX = '/ai-generated/';

// This value looks like a placeholder but is the actual string returned by the backend API.
export const AI_GENERATED_SUMMARY_ITEM = 'AI-GENERATED-TO-BE-DONE';
export const AI_GENERATED_ONE_PAGER_ITEM = 'AI-GENERATED-ONE-PAGER';
export const AI_GENERATED_PRACTICE_ITEM = 'AI-GENERATED-PRACTICE';

export const SUMMARY_STATUS_IN_PROGRESS = 'INPROGRESS';

export const LEARNING_BLOCK_FEEDBACK_PENDO_GUIDE_ID = 'RGUgNJQ1O1f6EbDCw2dXUMqyad0';
export const ONE_PAGER_FEEDBACK_PENDO_GUIDE_ID = 'AHn6MTqVof6DB4MQKJL7sttBl0w';
export const AI_GENERATED_SUMMARY_FEEDBACK_PENDO_GUIDE_ID = 'gCoucgRfr4j5WypmbI4jaj1Te7g';
export const LEARNING_PLAN_REVIEW_PENDO_GUIDE_ID = '4bXI3jnTx31fzeC2gRU99zvygnM';
export const COURSE_PROGRESS_DIALOG_PENDO_GUIDE_ID = 'FWI0C86egE4K9iMERi1ozx_pmKo';
